import PerformanceResource from "@/resources/PerformanceResource";

export default class Performance {
    constructor() {
        this.Resource = new PerformanceResource();
    }

    async get(name, startDate, endDate, page, reviewed, extraFilter) {
        const performance = await this.Resource.get(
            name,
            startDate,
            endDate,
            page,
            reviewed,
            extraFilter
        );
        return performance.data;
    }

    getExportLink(format, name, startDate, endDate, page, reviewed, extraFilter) {
        const query = this.Resource.getRequest(name, startDate, endDate, page, reviewed, extraFilter)

        return process.env.VUE_APP_REST_API + 'performance/export/' + format + '/' + query
    }

    async getAdvertiserNames(affiliateNetworkId = '', dateFrom = '') {
        const performance = await this.Resource.getAdvertiserNames(affiliateNetworkId, dateFrom);
        return performance.data;
    }
}
